export default __webpack_public_path__ + "static/media/CHT_MS2806_QSG_20190409.5c697626.pdf";